<template>
	<a :href="propertyUrl" target="_blank" class="property">
    <div class="property-image">
      <img :src="property.image" alt="" />
    </div>
    <div class="property-content">
      <span class="property-type">{{ property.type }}</span>
      <div class="property-price">
        <span>a partir de</span>
        <strong>{{ propertyPrice }}</strong>
      </div>
      <div class="property-location">
        <h4>{{ property.address }}</h4>
        <span> {{ property.district }}, {{ property.city }}</span>
      </div>
      <div class="property-info">
        <div v-if="property.size" class="property-item-min-box property-size">
          <img src="@/assets/img/franquias/icons/ruler.svg"/>
          <span>{{ property.size }} m<sup>2</sup></span>
        </div>
        <div v-if="property.bedrooms" class="property-item-min-box property-bedrooms">
          <img src="@/assets/img/franquias/icons/bed.svg"/>
          <span>{{ property.bedrooms }} quarto{{ property.bedrooms > 1 ? 's' : '' }}</span>
        </div>
        <div v-if="property.bathrooms" class="property-item-min-box property-bathrooms">
          <img src="@/assets/img/franquias/icons/showerHead.svg"/>
          <span>{{ property.bathrooms }} banheiro{{ property.bathrooms > 1 ? 's' : '' }}</span>
        </div>
        <div v-if="property.garage" class="property-item-min-box property-garage">
          <img src="@/assets/img/franquias/icons/car.svg"/>
          <span>{{ property.garage }} vaga{{ property.garage > 1 ? 's' : '' }}</span>
        </div>
        <div v-if="property.condominium" class="property-item-min-box property-condominium">
          <img src="@/assets/img/franquias/icons/gate.svg"/>
          Condomínio
        </div>
        <div v-if="property.pet" class="property-item-min-box property-pet">
          <img src="@/assets/img/franquias/icons/pets.svg"/>
          Aceita pet
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import '@/assets/scss/custom/franquias/components/_property-card.scss'
import { property } from 'lodash';
import utils from '../../../../utils';

export default {
	components: {
	},
	props: {
		property: {
			type: Object,
			required: true
		},
    idLoja: {
      type: Number,
			required: true
    }
	},
	computed: {
		propertyPrice() {
			return new Intl.NumberFormat('pt-BR', {
				style: 'currency',
				currency: 'BRL',
			}).format(this.property.price)
		},
    propertyUrl(){
      return `${utils.get_property_url(this.property.completeProperty, 'main')}?l=${this.property.completeProperty.codigoloja}`;
    }
	}
}
</script>